<template>
  <div class="container_box">
    <!--tab栏区域-->
    <Tabs v-model="tabStatus" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in statusList" :label="item.title" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1004303')" prop="channel">
              <Input clearable v-model.trim="pageParams.channel"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1004304')" prop="account">
              <Input clearable v-model.trim="pageParams.account"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001180')">
              <Date-picker
                :options="dateOptions"
                type="datetimerange"
                class="wid100P"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="createTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="tabStatus === 'null'">
            <Form-item :label="$t('key1001522')" prop="status">
              <Select v-model="pageParams.status">
                <Option v-for="(item, index) in statusList" :value="item.value" :key="index">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--新增收款账户-->
      <Button type="primary" class="mr15" @click="$refs['addReceivingAccount'].initAddReceivingAccountData('add')"
        v-if="getPermission('ymsReceivePayAccount_create')">{{ $t('key1004305') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="510"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--新增收款账户弹窗-->
    <addReceivingAccountModal ref="addReceivingAccount" @updateData="pageParamsStatus=true"></addReceivingAccountModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getAllUsersInfo, getUserNameByUserId} from "@/utils/common";
import addReceivingAccountModal from "@/views/yms/components/orderList/addReceivingAccountModal.vue";

export default {
  name: 'orderCollectionAccount',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      createTime: [],
      pageParams: {
        status: 'null',
        channel: null,
        account: null,
        createdStartTime: null,
        createdEndTime: null,
        pageNum: 1,
        pageSize: 15
      },
      tabStatus: 'null',
      originalColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004293'),
          align: 'center',
          key: 'channel',
          minWidth: 150
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004294'),
          align: 'center',
          key: 'account',
          minWidth: 150
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004295'),
          align: 'center',
          key: 'remark',
          minWidth: 250,
          render(h, params) {
            return v.checkContentOverflow(h, params.row.remark, 250, 1);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004296'),
          key: 'createdTime',
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002158'),
          key: 'createdBy',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            return h('div', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          align: 'center',
          minWidth: 150,
          render(h, params) {
            let typeList = [
              {type: 'error', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002631')},
              {type: 'success', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004297')}
            ];
            let status = params.row.status ? params.row.status : 0;
            return h('Badge', {
              props: {
                status: typeList[status].type,
                text: typeList[status].text || '--'
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          fixed: 'right',
          width: 200,
          render(h, params) {
            let ymsReceivePayAccountId = params.row.ymsReceivePayAccountId;
            let status = params.row.status;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004298'),
                    show: v.getPermission('ymsReceivePayAccount_update'),
                    clickFn: () => {
                      v.$refs['addReceivingAccount'].initAddReceivingAccountData('edit', ymsReceivePayAccountId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: status === 1 && v.getPermission('ymsReceivePayAccount_enableOrDisable'),
                    color: '#ed4014',
                    clickFn: () => {
                      v.enableDisableBtn('disable', ymsReceivePayAccountId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: status === 0 && v.getPermission('ymsReceivePayAccount_enableOrDisable'),
                    clickFn: () => {
                      v.enableDisableBtn('enable', ymsReceivePayAccountId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.getPermission('ymsReceivePayAccount_delete'),
                    clickFn: () => {
                      v.deleteReceivingAccountBtn(ymsReceivePayAccountId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableColumns: [],
      tableData: [],
      total: 0,
      statusList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: '1', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004297')},
        {value: '0', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002631')}
      ],
      userInfoList: {}
    };
  },
  created() {
    (async () => {
      await getAllUsersInfo().then(data => {
        this.userInfoList = data;
      });
    })();
    this.getList();
  },
  methods: {
    // 获取日期返回值
    getDateValue(value) {
      let v = this;
      if (value.length === 0 || !value[0]) {
        v.resetDate();
      } else {
        if (value[0] !== '') {
          let timeList = v.defaultTimePeriod(value);
          v.createTime = v.defaultTimePeriod(value, false);
          v.pageParams.createdStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.createdEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 重置时间
    resetDate() {
      this.createTime = [];
      this.pageParams.createdStartTime = null;
      this.pageParams.createdEndTime = null;
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      let nullKeyList = ['status'];
      for (let key of nullKeyList) {
        params[key] = v.pageParams[key] === 'null' ? null : Number(v.pageParams[key]);
      }
      return params;
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      v.handleColumns();
      v.optionBtnWidth = [];
      if (v.getPermission('ymsReceivePayAccount_queryList')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsReceivePayAccount_queryList, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.$refs['selection'].selectAll(false);
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.updateTableDom('selection');
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 重置按钮
    reset() {
      this.$refs['pageParams'].resetFields();
      this.createTime = [];
      this.resetDate();
      this.pageParams.status = this.tabStatus;
      this.pageParamsStatus = true;
    },
    // 切换Tab
    changeTab(value) {
      this.pageParams.status = value;
      this.pageParamsStatus = true;
    },
    // 启用、停用
    enableDisableBtn(type, ymsReceivePayAccountId) {
      let v = this;
      let text = type === 'enable' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002485') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002486');
      let query = {
        status: type === 'enable' ? 1 : 0,
        ymsReceivePayAccountId: ymsReceivePayAccountId
      };
      v.axios.put(api.put_ymsReceivePayAccount_enableOrDisable, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(text);
          v.getList();
        }
      });
    },
    // 删除收款账户
    deleteReceivingAccountBtn(ymsReceivePayAccountId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004299'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004300'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004301'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.delete(api.delete_ymsReceivePayAccount + ymsReceivePayAccountId,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004302'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {

        }
      });
    },
    // 处理列表字段
    handleColumns() {
      let v = this;
      v.tableColumns = [];
      let hideKeyList = [];
      if (['null'].includes(v.tabStatus)) {
        v.tableColumns = v.originalColumns;
      } else {
        hideKeyList = ['status'];
        v.tableColumns = v.originalColumns.filter((item) => {
          return !hideKeyList.includes(item.key);
        });
      }
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    addReceivingAccountModal
  }
};
</script>

<style lang="less">

</style>
